import React, { useLayoutEffect, useRef, useState } from 'react';

export const W = 1600;
export const H = 900;

export function Stage({ children, className = '', testId }: { children: React.ReactNode; className?: string; testId?: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const [s, setS] = useState(0);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ro = new ResizeObserver(() => setS(Math.min(el.clientWidth / W, el.clientHeight / H)));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return (
    <div ref={ref} className={`relative w-full h-full overflow-hidden flex items-center justify-center ${className}`}>
      <div style={{ width: W * s, height: H * s }} className="relative shrink-0" data-testid={testId}>
        <div style={{ width: W, height: H, transform: `scale(${s})`, transformOrigin: 'top left' }} className="absolute left-0 top-0 overflow-hidden">
          {children}
        </div>
      </div>
    </div>
  );
}
